<template>
    <div class="assets-details-in-metadata-manager">
        <div v-if="assetInfo == null || assetInfo == undefined" style="font-size: 20px; margin-top: 8%; color: #686868;text-align:center">
            No Data Found
        </div>
        <ul v-else>
            <li v-for="custommetadata in assetCustomMetadata" :key="custommetadata.key_id" class="d-block p-0">
                <ul class="m-0" v-if="'definition_type' in custommetadata && custommetadata.definition_type == 'system-defined'">
                    <li class="p-2 custom-metadata-rows">
                        <div class="key-style">{{ getCustomMetadataName(custommetadata.key_id) }}</div>
                        <div class="value-style d-inline-flex">
                            <template v-if="['PICKLIST','PICKLIST_MULTIVALUE'].includes(custommetadata.type)">
                                <div class="w-100" v-if="custommetadata.value.length">
                                  {{getPicklistValueNames(custommetadata.value)}}
                                </div>
                            </template>
                            <template v-else>
                                <div class="w-100" v-if="custommetadata.value.length">
                                  {{custommetadata.value.join(",")}}
                                </div>
                            </template>
                        </div>
                    </li>
                </ul>
            </li>
        </ul>
    </div>      
</template>


<script>
import Utils from "../../components.utils.js" ;
import {mapActions, mapGetters, mapMutations } from "vuex";
import {NotifierConstants} from "../../components.constants.js";

export default {
    props:["fileInfo", "context"],
    data(){
        return{
        fieldInfo:[],
        customMetadataList: [],
        assetInfo:null,
        isLoaded:false,
        assetId:null,
        assetDetails:{},
        picklistValue:{},
        assetCustomMetadata :[],
      }
    },
    computed:{
        getMimeType(){
            try{
                return Utils.getFileMediaType(this.assetDetails);
            }catch(e){
                console.log(e);
            }
            return '';
      },
      barcodeInfoFromStartup:{
        get(){
            return this.$store.state.startUpData.startUpDataDetails;
        }
      },
    },
    methods:{
        getPicklistValueNames(multiValueIds){
            if(multiValueIds != undefined && multiValueIds.length > 0){
                let valList =[];
                for(let valId of multiValueIds){
                    let valDetails = this.fieldInfo.filter(op=>op.value_id == valId);
                    if(valDetails.length > 0){
                        valList.push(valDetails[0].value);
                    }
                }
                return valList.join(", ");
            }
            return "None"
        },
        getCustomMetadataMapperName(fieldInfo){
            if('language_alias_mapper' in fieldInfo && fieldInfo.language_alias_mapper && fieldInfo.language_alias_mapper.length > 0 && this.$i18n && this.$i18n.locale){
                let mapperExists = fieldInfo.language_alias_mapper.find(op=>op.code == this.$i18n.locale)
                if(mapperExists && Object.keys(mapperExists).length > 0 && mapperExists.field_alias && mapperExists.field_alias.length > 0){
                    return mapperExists.field_alias;
                }
            }
            return fieldInfo.name;
        },
        getCustomMetadataName(id){
            let customMetadataDetails = this.customMetadataList.filter(c=>c._id == id);
            if(customMetadataDetails.length > 0){
                return this.getCustomMetadataMapperName(customMetadataDetails[0]);
            }
            return "";
        },
        setAssetInfo(info){
            this.assetDetails = {}
            Object.assign(this.assetDetails, info)
            if(Object.keys(this.assetDetails).includes("custom_metadata")){
                this.assetCustomMetadata = this.assetDetails.custom_metadata  
            }
            if(this.assetDetails.file_info){
                this.assetInfo.file_info = this.assetDetails.file_info;
            }
            this.isLoaded=true ;
        },
        refreshFileInfoAndShowAsset(fileId){
            let payload = {}
            if (this.assetId && Utils.getCookieValue("context") == 'catalogs-display'){
                payload.params = {assetId: this.assetId}
                this.getAssetInfoFromServer(payload).then((data) => {
                    this.setAssetInfo(data["asset"])
                })
            }else{
                payload.params = {fileId: fileId, metadata:true}
                this.getFileInfoFromServer(payload).then((data) => {
                    this.setAssetInfo(data["file"])
                })
            }
        },
        handlePropertiesNotification(notification){
            notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
            if(notification.message){
                if (this.assetInfo.asset_id == notification.message.asset_id){
                    this.refreshFileInfoAndShowAsset(this.assetInfo.file_uid);
                }else if (notification.message_type == NotifierConstants.assetRemovedCreatedNotification){
                    this.subclipsList = this.subclipsList.filter((asset)=>asset._id!=notification.message.asset_id)
                }else if(notification.message_type == NotifierConstants.assetCreatedNotification){
                    let temp = null;
                    if ("asset_id" in this.assetDetails){
                        temp = this.assetDetails.asset_id;
                    }else{
                        temp = this.assetDetails._id;
                    }
                    if(temp == notification.message.master_asset_id){
                        let payload = {}
                        payload.params = {assetId: notification.message.asset_id}
                        this.getAssetInfoFromServer(payload).then((data) => {
                            this.subclipsList.unshift(data.asset);
                        });
                    }
                }
            }
        },
        registerforWebsocketNotifications(){
            this.addWSEventListener({
                eventname:[NotifierConstants.assetModifiedNotification,NotifierConstants.assetCreatedNotification,NotifierConstants.assetRemovedCreatedNotification, NotifierConstants.fileModifiedNotification],
                callback:this.handlePropertiesNotification,
                parent: "BasicProperties"})
        },
        unRegisterforWebsocketNotifications(){
            this.removeWSEventListener({
                eventname:[NotifierConstants.assetModifiedNotification,NotifierConstants.assetCreatedNotification,NotifierConstants.assetRemovedCreatedNotification, NotifierConstants.fileModifiedNotification],
                callback:this.handlePropertiesNotification,
                parent: "BasicProperties"})
        },
        ...mapActions("customMetadata",["getAllCustomMetadataFromServer"]),
        ...mapActions("files", ["getFileInfoFromServer"]),
        ...mapActions("assets", ["getAssetInfoFromServer","getSubclipsFromServer"]),
        ...mapActions("assets",["getCategoryTreefromId"]),
        ...mapGetters("startUpData",["getStartUpDataFromInCache"]),
        ...mapMutations("websocket",["addWSEventListener", "removeWSEventListener"]),
    },
    beforeDestroy(){
        this.unRegisterforWebsocketNotifications()
    },
    created(){
        let assetOrFileId = ""
        if(this.fileInfo != undefined){
            this.assetInfo = this.fileInfo;
            if ("asset_id" in this.fileInfo){
                this.assetId = this.fileInfo.asset_id
            }else{
                this.assetId = this.fileInfo._id;
            }
            assetOrFileId = this.assetId;
        }
        if('file_uid' in this.assetInfo && this.assetInfo.file_uid != undefined){
            assetOrFileId = this.assetInfo.file_uid;
        }
        if(Object.keys(this.assetInfo).includes('field_info')){
            this.fieldInfo = this.assetInfo["field_info"];
          }
        this.refreshFileInfoAndShowAsset(assetOrFileId)
        if(Object.keys(this.getStartUpDataFromInCache()).includes("custom_metadatas")){
            this.customMetadataList = this.getStartUpDataFromInCache()["custom_metadatas"];
        }
        this.registerforWebsocketNotifications()
    },
}
</script>


<style lang="scss" scoped>
$table-row-border: none;
$active-blue: #007bff;
$danger-color: #dc3545;
$none-text-color:#4f4f4f;
$add-button-text-color:#0b7099;
$add-button-text-color-hover:#0193cc;
$add-button-border-color:#b7b228;
$add-button-border-on-hover:#dcd426;
$add-button-backgroud:#1e1e1e;
$active-green-color:#28a745;
$primary-background: #1a1e21;
$border-color: 1px solid #4a4a4a;
$primary-background: #1a1e21;
$secondary-background-color:#15181B;
$bg-color-on-hover: #22272b;
$text-color: #eee;
$dull-text-color: #757575;
$secondary-text-color: #9c9c9c;
$active-blue : #007bff;
$input-field-and-label-font-size:14px;
$input-field-height:38px;
$highlight-font-color:#ff9800;
$scrollbar-thumb-background:#333;
$scrollbar-track-background:#1a1e21;
$scrollbar-thumb-on-hover-background:#555; 
$input-field-padding:.375rem 10px;
$filter-border-color: #5a5a5a;
$filter-bg-color: #2a2a2a;
$learn-about-text-color-hover:#b7b327;
$learn-about-text-color:#9a9620;
$tags-background-color:#282d31;
$svg-color:#666;
$tags-border-color:#363636;
$secondary-border-color: 1px solid #2b2b2b;
$icon-hover:#2c3339;

ul{
    list-style-type: none;
    padding: 0px;
    margin-inline-start:10px;
    li{
        display:inline-flex;
        width: 100%;
        padding:7px;
        .key-style{
            color:$dull-text-color;
            width:17%;
            text-align: end;
        }
        .value-style{
            color: #b6b6b6;
            width: 80%;
            text-align: start;
            margin-inline-start: 11px;
            word-break: break-all;
        }
    }
}
.assets-details-in-metadata-manager{
  height:90%;
  overflow:auto
}

.view-tags {
  font-size: 12px !important;
  height: 24px !important;
  display: inline-flex !important;
  margin: 2px !important;
  border: $border-color !important;
  border-radius: 15px !important;
  min-width: 50px !important;
  padding: 0px !important;
  text-align: center;
  width: auto !important;
  padding-inline-start: 12px !important;
  justify-content: center;
  padding-top: 1px !important;
  span {
    padding: 0px 8px !important;
    margin-inline-start: 0px !important;
    font-size: 12px !important;
    border-radius: 15px !important;
    position: relative !important;
    top: 1px !important;
  }
}

.subclips-section{
  ul{
    width:93%;
    li{
      display: inline-block;
      width: 100%;
      padding: 7px;
      border: $border-color;
      border-radius: 4px;
      margin: 4px 8px;
      width: 96%;
      position: relative;
      background:$primary-background;
    }
  }
}

.transcript-section{
    display: inline-block;
    width: 100%;
    padding: 7px;
    border: $border-color;
    border-radius: 4px;
    margin: 4px 8px;
    width: 96%;
    position: relative;
    background:$primary-background;
}

.active-subclip-preview{
  border: 2px solid $active-blue !important;
}

.change-the-text-color{
    text-transform: uppercase;
    height: 22px;
    width: fit-content;
    border-radius: 10px;
    padding: 3px 9px;
    font-size: 10px;
    letter-spacing: 0.5px;
  }

  .value-style{
    display: flex;
    flex-wrap: wrap
  }

  .wrap-file-info{
    border: 1px solid #384445;
    border-radius: 10px;
    background: #202729 !important;
    margin: 10px 5px;
    padding: 5px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    position: relative;
    margin-top: 0px;
  }

  .transcript-play {
    display: flex;
    align-items: flex-start;
    gap: 6px;
    position: relative;
    // inset-inline-start :-20px;
    .transcript-play-pause{
        //  visibility: hidden;
        svg{
          fill:#5e5e5e !important;
        }
         position: relative;
        //  inset-inline-start:5px;
         svg {
            fill : #5e5e5e !important;
         }
     }
  }
  .transcript-list:hover .transcript-play-pause{
    //  visibility: visible;
    svg{
      fill:#eee !important;
    }
     cursor: pointer;
  }

  .transcript-and-timescode {
    display: flex;
    align-items: center;
 }

  .icon-background-on-hover:hover{
    background: #d1d2d31a;
    cursor: pointer;
  }

.icon-background-on-hover{
    padding: 6px;
    height: 28px;
    width: 28px;
    border-radius: 4px;
    cursor: pointer;
  }

  .common-media-in-out-display{
          font-size: 14px;
          background: rgb(52, 52, 52);
          padding: 4px 5px; 
          justify-content: start; 
          display: flex; 
          border-radius: 3px;
          color: rgb(238, 238, 238) !important;
          gap:3px;
    }

  .storage-type-icon{
    margin-inline-end:4px;
    margin-top:2px;
  }
</style>